import {setImageSizes} from './images';
import setSliderPosition from './slider';

const size = () => {
  setImageSizes();
  setSliderPosition(window.innerWidth / 2);
};

export default size;
